import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  'コンタクトレンズを簡単に注文できるスマホアプリを開発いたしました。このアプリは、ユーザー体験に重点を置き、アプリを開いてすぐに購入できるような、PUSH通知からのシナリオを描いた導線設計やUI設計を行いました。弊社はウォークスルーのイラスト・アニメーションからアプリの開発まで実施しました。'

const ogpImg = 'https://aitria.co.jp/images/img/cases/visionaryholdings/ogp_visionaryholdings.png'

export const visionaryholdingsPageMeta: PageMeta = {
  title: 'コンタクトレンズが簡単注文できるアプリ | 事例 | Aitria（アイトリア）',
  description,
  keyword: 'flamingo UX/UI モダナイゼーション JavaScript ウェブシステム',
  image: ogpImg,
  url: `${SITE_URL}/cases/visionaryholdings/`,
}

export const visionaryholdingsSchema = buildCaseStudySchema({
  slug: 'visionaryholdings',
  pageTitle: visionaryholdingsPageMeta.title,
  description: visionaryholdingsPageMeta.description,
  headline: 'コンタクトレンズが簡単注文できるアプリ',
  alternativeHeadline: '株式会社ビジョナリーホールディングス',
  primaryImage: ogpImg,
  images: [
    ogpImg,
    'https://aitria.co.jp/images/img/cases/caseStudyTop/visionaryholdings.webp',
  ],
  clientName: '株式会社ビジョナリーホールディングス',
  breadcrumbLabel: 'コンタクトレンズが簡単注文できるアプリ',
})
